import { Component, OnInit, ViewChild } from '@angular/core';
import { MatStepper } from '@angular/material/stepper';
import { WizardService } from 'app/main/wizard-cgo/services/wizard.service';
import { lang_shedule } from 'app/idiomas/i18n/shedule/shedule.lang';
import { lang_leaderGo } from 'app/idiomas/i18n/leaderGo/leaderGo.lang';
import { lang_modales } from 'app/idiomas/i18n/modales/modales.lang';
import { lang_idiomas } from 'app/idiomas/i18n/idiomas/idiomas.lang';
import { lang_perfiles } from 'app/idiomas/i18n/perfiles/perfiles.lang';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { Subject } from 'rxjs';
import {MatSnackBar} from '@angular/material/snack-bar';
@Component({
  selector: 'app-programacion',
  templateUrl: './programacion.component.html',
  styleUrls: ['./programacion.component.scss']
})
export class ProgramacionLeaderComponent implements OnInit {

  @ViewChild('pasos') pasos: MatStepper;

  enviaDatosEditor: Subject<any> = new Subject<any>();
  actualizaEmail: Subject<any> = new Subject<any>();
  instituto: number;

  constructor(
    private wizardService: WizardService,
    private _fuseTranslationLoaderService: FuseTranslationLoaderService
  ) {
    lang_shedule.forEach((locale) => {
        this._fuseTranslationLoaderService.loadTranslations(locale);
    });
    lang_modales.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });
    lang_idiomas.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });
    lang_perfiles.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });
    lang_leaderGo.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });
  }

  ngOnInit() {
    this.getInstituto();
  }

  cambiaPaso(numero:number){
    this.pasos.selectedIndex = numero;
    if(numero == 1){
      this.actualizaEmail.next(true);
    }
  }

  enviaInfoEditor(datos:any) {
    this.enviaDatosEditor.next(datos);
  }

  getInstituto(){
    switch(this.wizardService.getInstituto()){
      case '1': case 'MX': this.instituto = 1; break;
      case '2': case 'CAyC': this.instituto = 2; break;
      case '3': case 'HK': this.instituto = 3; break;
      case '4': case 'SGP': this.instituto = 4; break;
      case '5': case 'TK': this.instituto = 5; break;
      case '6': case 'FL': this.instituto = 6; break;
      case '8': case 'IZZI': this.instituto = 8; break;
      case '11': case 'BR': this.instituto = 11; break;
      case '14': case 'GCTI': this.instituto = 14; break;
      case '15': case 'ES': this.instituto = 15; break;
    }
    console.log(this.instituto);

  }

}
